import Container from '@components/ui-old/container';
import Layout from '@components/layout/layout';
import { ShopFilters } from '@components/shop/filters';
import StickyBox from 'react-sticky-box';
import { ProductGrid } from '@components/product/product-grid';
import SearchTopBar from '@components/shop/top-bar';
import ActiveLink from '@components/ui-old/active-link';
import { BreadcrumbItems } from '@components/common/breadcrumb';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ROUTES } from '@utils/routes';
import { GetServerSideProps } from 'next';
import { useProductsQuery } from '@framework/product/get-all-products';
import React, { useEffect, useState } from 'react';
import ShopBanner from '@containers/shop-banner';
import QuickOrderModal from '@components/product/express-shopping';
import { NextSeo } from 'next-seo';
import { siteSettings } from '@settings/site-settings';
import InstaStory from '@components/other/insta-story';
import { IconArrowUp } from '@tabler/icons-react';
export default function Shop() {
  const {
    t
  } = useTranslation('common');
  const {
    data,
    error
  } = useProductsQuery({
    limit: 10
  });
  const totalItems = data?.pages?.[0]?.paginatorInfo?.total || data?.pages?.[0]?.results?.length || 0;
  if (error) return <p>{error.message}</p>;
  function ScrollToTopButton() {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
      const toggleVisibility = () => {
        if (window.pageYOffset > 200) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      };
      window.addEventListener('scroll', toggleVisibility);
      return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    return <button onClick={scrollToTop} className={`fixed bottom-16 left-1/2 -translate-x-1/2 z-50 px-2 py-2 bg-neutral-400 text-neutral-900 dark:bg-neutral-600 dark:text-neutral-200 text-sm rounded-full shadow-md transition-opacity duration-300 ${visible ? 'opacity-100' : 'opacity-0'} lg:hidden`} data-sentry-component="ScrollToTopButton" data-sentry-source-file="index.tsx">
        <IconArrowUp size={20} data-sentry-element="IconArrowUp" data-sentry-source-file="index.tsx" />
      </button>;
  }
  return <>
      <NextSeo title={`${t('menu:menu-shop') || "Shop"} - ${siteSettings.name}`} description={t('common:shop-description') || "Forever Living Product"} canonical={`${siteSettings.author.websiteUrl}shop`} openGraph={{
      url: `${siteSettings.author.websiteUrl}shop`,
      title: `${t('menu:menu-shop') || "Shop"} - ${siteSettings.name}`,
      description: t('common:shop-description') || "Forever Living Product",
      images: [{
        url: `${siteSettings.author.websiteUrl}assets/images/og-image-shop.jpg`,
        width: 1200,
        height: 630,
        alt: `${t("menu:menu-shop")}`
      }],
      site_name: siteSettings.name
    }} twitter={{
      handle: "@handle",
      site: "@site",
      cardType: "summary_large_image"
    }} data-sentry-element="NextSeo" data-sentry-source-file="index.tsx" />
      <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
        <ShopBanner data-sentry-element="ShopBanner" data-sentry-source-file="index.tsx" />
        <div className={`flex pt-8 pb-16 lg:pb-20`}>
          <div className="flex-shrink-0 ltr:pr-24 rtl:pl-24 hidden lg:block w-96">
            <StickyBox offsetTop={50} offsetBottom={20} data-sentry-element="StickyBox" data-sentry-source-file="index.tsx">
              <div className="pb-7">
                <BreadcrumbItems separator="/" data-sentry-element="BreadcrumbItems" data-sentry-source-file="index.tsx">
                  <ActiveLink href={'/'} activeClassName="font-semibold text-heading dark:text-neutral-200" data-sentry-element="ActiveLink" data-sentry-source-file="index.tsx">
                    <a>{t('breadcrumb-home')}</a>
                  </ActiveLink>
                  <ActiveLink href={ROUTES.SHOP} activeClassName="font-semibold text-heading dark:text-neutral-200" data-sentry-element="ActiveLink" data-sentry-source-file="index.tsx">
                    <a className="capitalize">{t('breadcrumb-shop')}</a>
                  </ActiveLink>
                </BreadcrumbItems>
              </div>
              <QuickOrderModal data-sentry-element="QuickOrderModal" data-sentry-source-file="index.tsx" />
              <ShopFilters data-sentry-element="ShopFilters" data-sentry-source-file="index.tsx" />
              <InstaStory data-sentry-element="InstaStory" data-sentry-source-file="index.tsx" />
            </StickyBox>
          </div>

          <div className="w-full ltr:lg:-ml-9 rtl:lg:-mr-9">
            <SearchTopBar totalItems={totalItems} data-sentry-element="SearchTopBar" data-sentry-source-file="index.tsx" />
            <ProductGrid data-sentry-element="ProductGrid" data-sentry-source-file="index.tsx" />
          </div>
        </div>
      </Container>
      <ScrollToTopButton data-sentry-element="ScrollToTopButton" data-sentry-source-file="index.tsx" />
    </>;
}
Shop.Layout = Layout;
export const getServerSideProps: GetServerSideProps = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale!, ['common', 'forms', 'menu', 'footer', 'swal']))
    }
  };
};